import { render } from "./IconHalo.vue?vue&type=template&id=641f2072&scoped=true"
import script from "./IconHalo.vue?vue&type=script&lang=js"
export * from "./IconHalo.vue?vue&type=script&lang=js"

import "./IconHalo.vue?vue&type=style&index=0&id=641f2072&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641f2072"]])

export default __exports__